import { render, staticRenderFns } from "./customDashboardStats.vue?vue&type=template&id=117cf727&scoped=true"
import script from "./customDashboardStats.vue?vue&type=script&lang=js"
export * from "./customDashboardStats.vue?vue&type=script&lang=js"
import style0 from "./customDashboardStats.vue?vue&type=style&index=0&id=117cf727&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cf727",
  null
  
)

export default component.exports